import type { Map as MapboxMap } from 'mapbox-gl';

/** Keep lighting stable across gestures, without dynamic shadow-map passes. */
export function attachRenderQuality(map: MapboxMap) {
  const apply = () => {
    let lights: ReturnType<MapboxMap['getLights']>;
    try { lights = map.getLights(); } catch { return; }
    const light = lights?.find(light => light.type === 'directional');
    if (!light || light.type !== 'directional' || light.properties?.['cast-shadows'] === false) return;
    // Preserve directional color/intensity and all basemap preset expressions.
    // Imported fragments can announce readiness before the root style is ready.
    try {
      map.setLights([{ ...light, properties: { ...light.properties, 'cast-shadows': false } }]);
    } catch { /* The root style.load event will retry. */ }
  };
  map.on('style.load', apply);
  map.on('style.import.load', apply);
  if (map.isStyleLoaded()) apply();
  return () => { map.off('style.load', apply); map.off('style.import.load', apply); };
}
